import api from 'core/util/api';
import { DeviceTag } from '@kentik/ui-shared/dictionary/types';
import { UseQueryOptions } from '@tanstack/react-query';

const queryFn = () => api.get('/api/ui/dictionary/deviceTags') as Promise<DeviceTag[]>;

export const deviceTagsQuery = {
  queryKey: ['deviceTagsRaw'] as const,
  queryFn,
  staleTime: 300000
} as const satisfies UseQueryOptions<DeviceTag[], Error, DeviceTag[], readonly ['deviceTagsRaw']>;
